import { cleanStorage } from "@/lib/webStorage";
import { showLogoutWarningConfirm } from "@/lib/antdElementFunction";
import { getLangList } from "@/lib/i18n";

export const dataTrim = (data: any) => {
  const newData: any = Array.isArray(data) ? [] : {};
  Object.keys(data).forEach((item: any) => {
    newData[item] = (data[item] && typeof data[item] === 'string') ? data[item].trim() : data[item];
  });
  return newData;
};

export const deleteUnusedKey = (data: any) => {
  const formatData = Object.assign({}, data);
  for (const key in formatData) {
    if (formatData[key] === '') {
      delete formatData[key];
    }
  }
  return formatData;
};

export const kickUnauthorized = () => {
  const t: any = getLangList("error");
  showLogoutWarningConfirm(() => {
    cleanStorage();
  }, t.unauthorized);
};